import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppWidget = () => {
  const [hovered, setHovered] = useState(false);
  const phoneNumber = "971503469515";
  const handleClick = () => {
    window.open(
      `https://api.whatsapp.com/send/?phone=${phoneNumber}&text&type=phone_number&app_absent=0`,
      "_blank"
    );
  };
  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
      }}
    >
      {hovered && (
        <div
          style={{
            position: "absolute",
            bottom: "50%",
            right: "110%",
            backgroundColor: "white",
            color: "black",
            padding: "5px 10px",
            borderRadius: "5px",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
            whiteSpace: "nowrap",
          }}
        >
          Chat with us
        </div>
      )}
      <div
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: "50px",
          height: "50px",
          backgroundColor: "#4dc247",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.15)",
        }}
      >
        <FaWhatsapp size={28} color="white" />
      </div>
    </div>
  );
};

export default WhatsAppWidget;
